export const SESSION_STORAGE_KEYS = {
  SESSION_ID: "koalaSessionId",
  SESSION_START: "koalaSessionStartTime",
};
